import { render, staticRenderFns } from "./privacyPolicyListing.vue?vue&type=template&id=5e67ecd2&scoped=true&"
var script = {}
import style0 from "./privacyPolicyListing.vue?vue&type=style&index=0&id=5e67ecd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e67ecd2",
  null
  
)

export default component.exports